// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ZZ6Vp","dark":"Footer_dark__SHypk"};